import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsManjaroComponent } from './simple-icons-manjaro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsManjaroComponent ],
    exports:      [ SimpleIconsManjaroComponent ],
    bootstrap:    []
})
export class SimpleIconsManjaroModule {}
